import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MiniStartAnalytics" */ './lazyIndex')
);

/**
 * This port of ariaUtils.ts is done to lazy-load the analytics bundle to improve startup performance.
 * The shared-start code in shared/internal bundles @microsoft/1ds-core-js and other telemetry packages
 * as part of the index bundle.
 *
 * This code has to be kept upto data with shared/internal/owa-shared-start/src/ariaUtils when we perform shared
 * package updates
 */
export const lazyPostSignal = new LazyAction(lazyModule, m => m.postSignal);

export const lazySetAriaTenantToken = new LazyAction(lazyModule, m => m.setAriaTenantToken);
